export const BEFORE_FETCH_PROMOTIONS = 'BEFORE_FETCH_PROMOTIONS';
export const FETCH_PROMOTIONS = 'FETCH_PROMOTIONS';
export const ERROR_FETCHING_PROMOTIONS = 'ERROR_FETCHING_PROMOTIONS';
export const BEFORE_VERIFY_PROMOTION = 'BEFORE_VERIFY_PROMOTION';
export const VERIFY_PROMOTION = 'VERIFY_PROMOTION';
export const ERROR_VERIFYING_PROMOTION = 'ERROR_VERIFYING_PROMOTION';

export const BEFORE_CLAIM_PROMOTION = 'BEFORE_CLAIM_PROMOTION';
export const CLAIM_PROMOTION = 'CLAIM_PROMOTION';
export const ERROR_CLAIMING_PROMOTION = 'ERROR_CLAIMING_PROMOTION';